import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { PANEL_WIDTH } from './AgentSurface'
import { AiForwardPlacement } from './AiForwardPlacement'
import { DESKTOP_WIDTH, OptionSection } from './OptionSection'
import { ReactAppMock } from './ReactAppMock'

/** Option 2, with the same notification trigger Option 1 carries. */
export function AiForwardOptionSection({
  shellClass,
  shellHeight,
}: {
  shellClass: string
  shellHeight: number
}) {
  const [notificationId, setNotificationId] = useState(0)

  return (
    <OptionSection
      title="Option 2: Desktop more AI-forward"
      action={
        <Button size="sm" variant="outline" onClick={() => setNotificationId((id) => id + 1)}>
          Send a notification
        </Button>
      }
      panes={[
        {
          label: 'React app',
          width: PANEL_WIDTH,
          content: <ReactAppMock height={shellHeight} notified={notificationId > 0} />,
        },
        {
          label: 'Desktop',
          width: DESKTOP_WIDTH,
          content: <AiForwardPlacement notificationId={notificationId} className={shellClass} />,
        },
      ]}
    />
  )
}
